<template>
  <div class="recharge-activity-page">
    <div class="recharge-activity">充值活动</div>
    <div class="flex-row-start">
      <div class="activity-name">活动名称</div>
      <el-input
        placeholder="请输入活动名称"
        v-model="keywords"
        style="width: 220px"
        class="pr30"
      ></el-input>
      <el-select
        v-model="value"
        placeholder="请选择"
        class="pr30"
        @change="cardstatusChange"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="search">搜索</el-button>
      <el-button type="success" @click="dialogVisible = true">添加活动</el-button>
    </div>
    <div class="table-area">
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
        element-loading-text="数据正在加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          align="center"
          prop="activityName"
          label="活动名称"
        ></el-table-column>
        <el-table-column align="center" prop="activityType" label="活动类型">
          <template slot-scope="scope">
            <div>{{ scope.row.activityType == 1 ? "充值活动" : "" }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="startTime" label="活动开始时间">
          <template slot-scope="scope">
            {{ scope.row.expireType == 0 ? scope.row.createTime : scope.row.startTime }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="endTime" label="活动结束时间">
          <template slot-scope="scope">
            {{ scope.row.expireType == 0 ? "永久" : scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="shopMemberCardIds" label="会员卡">
          <template slot-scope="scope">
            <div>已绑定{{ scope.row.shopMemberCardIds.split(",").length }}张</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isEnable" label="状态">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.isEnable == 1 ? "可用" : scope.row.isEnable == 0 ? "不可用" : ""
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="320px">
          <template slot-scope="scope">
            <el-button @click="lookDetail(scope.row)">查看</el-button>
            <el-button @click="stopRecharge(scope.row)" v-if="scope.row.isEnable == 1"
              >停用</el-button
            >
            <el-button @click="deleteRecharge(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        v-if="tableData.length > 0"
        class="block"
        style="float: right; margin-top: 10px"
      >
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNo"
          :page-size="queryInfo.row"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 查看添加对话框 -->
    <el-dialog
      title="充值送"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <span>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="活动名称" prop="activityName">
            <el-input
              v-model="ruleForm.activityName"
              placeholder="请输入活动名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动金额" prop>
            <div class="activity-area">
              <div class="flex-row-starts" v-for="(item, i) in activityList" :key="i">
                <span class="pr15">充</span>
                <el-input
                  style="width: 130px"
                  class="pr15"
                  v-model="item.rechargeMoney"
                  onchange="this.value=this.value.replace(/[^\d]/g,'')"
                ></el-input>
                <span class="pr15">送</span>
                <el-input
                  style="width: 130px"
                  class="pr15"
                  v-model="item.handselMoney"
                  onchange="this.value=this.value.replace(/[^\d]/g,'')"
                ></el-input>
                <el-button type="text" @click="del(i)" v-if="activityList.length >= 2"
                  >删除</el-button
                >
              </div>
              <el-button type="text" @click="add">添加</el-button>
            </div>
          </el-form-item>
          <el-form-item label="活动时间：" prop="expireType">
            <el-radio-group v-model="ruleForm.expireType">
              <el-radio label="永久"></el-radio>
              <el-radio label="设置时间"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.expireType == '设置时间'" label prop="date">
            <el-date-picker
              v-model="ruleForm.date"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="会员卡：" prop="shopMemberCardIds">
            <el-select
              size="small"
              v-model="ruleForm.shopMemberCardIds"
              multiple
              placeholder="请选择"
              @change="shopMemberCardIdsChange"
            >
              <el-option
                v-for="item in memberCardList"
                :key="item.shopMemberCardId"
                :label="item.cardName"
                :value="item.shopMemberCardId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            (dialogVisible = false),
              (isLook = false),
              (ruleForm = {}),
              (activityList = [{ rechargeMoney: '', handselMoney: '' }])
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="confirmAdd" v-if="isLook == false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRechargeList,
  stopRecharge,
  deleteRecharge,
  getShopMemberCardList,
  updateRecharge,
} from "@/api/index";
export default {
  data() {
    return {
      keywords: "",
      value: "",
      options: [
        { value: "", label: "全部" },
        { value: "1", label: "可用" },
        { value: "0", label: "不可用" },
      ],
      tableData: [],
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      loading: false,
      status: "",
      dialogVisible: false,
      ruleForm: {
        activityName: "",
        date: "",
        shopMemberCardIds: "",
        expireType: "永久",
      },
      rules: {
        activityName: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        rechargeMoney: [{ required: true, message: "请输入活动金额", trigger: "blur" }],
        expireType: [{ required: true, message: "请输入活动时间", trigger: "change" }],
        date: [{ required: true, message: "请输入活动时间", trigger: "change" }],
        shopMemberCardIds: [
          { required: true, message: "请选择会员卡", trigger: "change" },
        ],
      },
      activityList: [{ rechargeMoney: "", handselMoney: "" }],
      memberCardList: [],
      isLook: false,
    };
  },
  created() {
    this.getRechargeList();
  },
  methods: {
    getRechargeList(activityName, isEnable) {
      this.loading = true;
      getRechargeList({
        pageNumber: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        activityName: activityName,
        isEnable: isEnable,
      }).then((res) => {
        this.loading = false;
        if (res.code == 1) {
          this.tableData = res.data.pager.list;
          this.total = res.data.pager.totalCount;
          this.getShopMemberCardList();
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      this.keywords = this.keywords.trim();
      if (this.status == 1) {
        this.getRechargeList(this.keywords, this.value);
      } else {
        this.getRechargeList();
      }
    },
    search() {
      this.keywords = this.keywords.trim();
      this.status = 1;
      this.getRechargeList(this.keywords, this.value);
      this.queryInfo.pageNo = 1;
    },
    cardstatusChange(val) {
      if (!val) {
        this.getRechargeList();
      } else {
        this.getRechargeList("", val);
      }
    },
    stopRecharge(row) {
      this.$confirm("此操作将停用该活动, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          stopRecharge({
            shopMemberActivityId: row.shopMemberActivityId,
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.getRechargeList();
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "取消输入"
          // });
        });
    },
    deleteRecharge(row) {
      this.$confirm("此操作将删除该活动, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          deleteRecharge({
            shopMemberActivityId: row.shopMemberActivityId,
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.getRechargeList();
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "取消输入"
          // });
        });
    },
    handleClose() {
      this.dialogVisible = false;
      this.isLook = false;
      this.ruleForm = {};
      this.activityList = [{ rechargeMoney: "", handselMoney: "" }];
    },
    lookDetail(row) {
      this.isLook = true;
      this.dialogVisible = true;
      this.ruleForm.activityName = row.activityName;
      this.activityList = JSON.parse(row.itemContent);
      this.ruleForm.expireType =
        row.expireType == 1 ? "设置时间" : row.expireType == 0 ? "永久" : "";
      if (row.expireType == 1) {
        this.ruleForm.date = [row.startTime, row.endTime];
      }
      var shopMemberCardIds = row.shopMemberCardIds.split(",");
      for (let i in shopMemberCardIds) {
        shopMemberCardIds[i] = Number(shopMemberCardIds[i]);
      }
      this.ruleForm.shopMemberCardIds = shopMemberCardIds;
    },
    add() {
      this.activityList.push({ rechargeMoney: "", handselMoney: "" });
    },
    del(i) {
      this.activityList.splice(i, 1);
    },
    getShopMemberCardList() {
      getShopMemberCardList({
        pageNo: 1,
        row: 999,
        isEnable: 1,
        isExpire: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.memberCardList = res.data;
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    shopMemberCardIdsChange(val) {
      console.log(typeof val, val);
    },
    confirmAdd() {
      console.log(
        typeof this.ruleForm.shopMemberCardIds,
        this.ruleForm.shopMemberCardIds
      );
      var shopMemberCardIds;
      var obj = this.ruleForm.shopMemberCardIds;
      shopMemberCardIds = obj.join(","); // #
      console.log(shopMemberCardIds, typeof shopMemberCardIds);
      // return
      var arr = this.activityList;
      var bool = arr.some((item) => {
        return (
          !item.handselMoney ||
          !item.rechargeMoney ||
          Number(item.rechargeMoney) < Number(item.handselMoney)
        );
      });
      if (bool) {
        this.$message.error(
          "赠送金额或充值金额不能为空，并且充值金额不能小于赠送金额哦~"
        );
        return;
      }
      arr = JSON.stringify(arr);
      var expireType = this.ruleForm.expireType;
      if (expireType == "永久") {
        expireType = 0;
      } else {
        expireType = 1;
      }
      updateRecharge({
        activityName: this.ruleForm.activityName,
        expireType: expireType,
        itemContent: arr,
        shopMemberCardIds: String(shopMemberCardIds),
        activityType: 1,
        startTime: this.ruleForm.date[0] !== "undefined" ? this.ruleForm.date[0] : "",
        isEnable: 1,
        endTime: this.ruleForm.date[1] !== "undefined" ? this.ruleForm.date[1] : "",
      }).then((res) => {
        this.dialogVisible = false;
        if (res.code == 1) {
          this.$message.success(res.msg);
          this.ruleForm = {};
          this.activityList = [{ rechargeMoney: "", handselMoney: "" }];
          this.getRechargeList();
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.pr30 {
  padding-right: 30px;
  box-sizing: border-box;
}
.pr15 {
  padding-right: 15px;
  box-sizing: border-box;
}
.flex-row-starts {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-bottom: 10px;
  box-sizing: border-box;
}
.recharge-activity-page {
  padding: 30px 20px 20px 30px;
  box-sizing: border-box;
  height: calc(100% - 80px);
  overflow-y: scroll;
  .recharge-activity {
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
    box-sizing: border-box;
  }
  .flex-row-start {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: 30px 0;
    box-sizing: border-box;
    .activity-name {
      padding-right: 10px;
      box-sizing: border-box;
      line-height: 40px;
    }
  }
  .table-area {
    padding-top: 25px;
    box-sizing: border-box;
  }
}
/deep/ .el-table th {
  background-color: #f7f8fa;
}
.activity-area {
  width: 420px;
  height: auto;
  background: #f2f2f2;
  padding: 15px;
  box-sizing: border-box;
}
</style>
